import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import RegistrationSection from "@/components/RegistrationSection";
import InstagramSection from "@/components/InstagramSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";

import { useSeo } from "@/lib/seo";
export default function HomePage() {
  useSeo({ title: "Academy — Beach Volley Training in Chania", description: "Beach volleyball academy in Chania, Crete: Silver & Golden training levels, coaching for all ages and open court sessions. Join The Sand Lab.", path: "/academy" });
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <Hero />
      <RegistrationSection />
      <InstagramSection />
      <FAQSection />
      <Footer />
    </div>
  );
}
